// Registry de funções de aprovação
// Mapa: chave -> definição da função

const registry = new Map()

/**
 * Registra uma definição de função de aprovação
 * @param {string} chave - Chave única da função (ex: 'OrdemCompra')
 * @param {Object} definicao - Definição completa da função
 */
export function registrarFuncao (chave, definicao) {
  if (registry.has(chave)) {
    console.warn(`[aprovacoesRegistry] Função "${chave}" já registrada. Substituindo...`)
  }
  registry.set(chave, definicao)
}

/**
 * Obtém a definição de uma função de aprovação pela chave
 * @param {string} chave
 * @returns {Object} definicao
 * @throws {Error} Se a chave não estiver registrada
 */
export function obterDefinicao (chave) {
  if (!registry.has(chave)) {
    throw new Error(`[aprovacoesRegistry] Nenhuma função registrada para a chave "${chave}".`)
  }
  return registry.get(chave)
}

/**
 * Lista todas as chaves registradas
 * @returns {string[]}
 */
export function listarChaves () {
  return Array.from(registry.keys())
}
